<div class="list-page kapea" style="max-width: 1500px">
  <mat-tab-group>
    <mat-tab label="Työjonot">
      <div class="light-blue-text otsikko" style="margin-top: 1em">
        <div style="margin-right: auto">Tietokantojen työjonossa olevat työt</div>
      </div>
      <div style="margin: 1em 0 2em 0.5em; font-style: italic">Huomio: tämä sivu ei näytä live-dataa, joten mikäli esimerkiksi käynnistät työjonon uudelleen, pitää päivittää sivu nähdäkseen, poistuiko se listalta.</div>

      <h2>Lemonaid</h2>

      <button mat-button class="secondarybutton" style="margin-bottom: 2em" (click)="fetchLogs('lemonaid')">Hae Lemonaidin logit</button>
      @if (lemonaidLogs()?.length; as noLemonaidLogs) {
        <table>
          @for (log of lemonaidLogs(); track log) {
            <tr class="log-entry">
              <td>{{ log.timestamp }}</td>
              <td>
                <button mat-button (click)="openCloudLoggingConsole('lemonaid', log.trace)">{{ log.trace }}</button>
              </td>
              <td>{{ log.resource.labels?.function_name }}</td>
              <td class="long-td">{{ log.textPayload }}</td>
            </tr>
          }
        </table>
      }

      <h3>Työjonot</h3>
      @if (lemonaidTyojonot()?.length) {
        <button mat-button class="primarybutton" style="margin-bottom: 2em" (click)="restartAllTyojonot('lemonaid')">Käynnistä kaikki Lemonaidin työjonot uudestaan</button>
      }
      <div class="tyojonot-container">
        @for (tyojono of lemonaidTyojonot() || []; track tyojono) {
          <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span (click)="openLink(tyojono.tyojonoUri, 'lemonaid', $event)" class="fa fa-external-link link-btn" matTooltip="Avaa työjono Firestoressa"></span>
                    @if (!tyojono.restartState) {
                      <span (click)="restartTyojono('lemonaid', tyojono, $event)" class="fa fa-repeat link-btn" matTooltip="Käynnistä työjono uudestaan"></span>
                    }
                    @if (tyojono.restartState === 'loading') {
                      <mat-spinner class="small-spinner link-btn"></mat-spinner>
                    }
                    @if (tyojono.restartState === 'done') {
                      <span class="fa fa-check link-btn" matTooltip="Käynnistetty uudelleen"></span>
                    }
                    <span (click)="openCustomer(tyojono.tyojonoUri, $event)" class="fa fa-user link-btn" matTooltip="Avaa asiakas, johon tämä liittyy"></span>
                    Työjono {{ tyojono.tyojonoUri }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <pre>{{ tyojono.data | json }}</pre>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
        @if (lemonaidLoading()) {
          <div>
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
        }
      </div>

      <h2 style="margin-top: 2em">Lemonator</h2>

      <button mat-button class="secondarybutton" style="margin-bottom: 2em" (click)="fetchLogs('lemonator')">Hae Lemonatorin logit</button>
      @if (lemonatorLogs()?.length) {
        <table>
          @for (log of lemonatorLogs(); track log) {
            <tr class="log-entry">
              <td>{{ log.timestamp }}</td>
              <td>
                <button mat-button (click)="openCloudLoggingConsole('lemonator', log.trace)">{{ log.trace }}</button>
              </td>
              <td>{{ log.resource.labels?.function_name }}</td>
              <td class="long-td">{{ log.textPayload }}</td>
            </tr>
          }
        </table>
      }

      <h3>Työjonot</h3>
      @if (lemonatorTyojonot()?.length) {
        <button mat-button class="primarybutton" style="margin-bottom: 2em" (click)="restartAllTyojonot('lemonator')">Käynnistä kaikki Lemonatorin työjonot uudestaan</button>
      }
      <div class="tyojonot-container">
        @for (tyojono of lemonatorTyojonot() || []; track tyojono) {
          <div>
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span (click)="openLink(tyojono.tyojonoUri, 'lemonator', $event)" class="fa fa-external-link link-btn" matTooltip="Avaa työjono Firestoressa"></span>
                    @if (!tyojono.restartState) {
                      <span (click)="restartTyojono('lemonator', tyojono, $event)" class="fa fa-repeat link-btn" matTooltip="Käynnistä työjono uudestaan"></span>
                    }
                    @if (tyojono.restartState === 'loading') {
                      <mat-spinner class="small-spinner link-btn"></mat-spinner>
                    }
                    @if (tyojono.restartState === 'done') {
                      <span class="fa fa-check link-btn" matTooltip="Käynnistetty uudelleen"></span>
                    }
                    <span (click)="openCustomer(tyojono.tyojonoUri, $event)" class="fa fa-user link-btn" matTooltip="Avaa asiakas, johon tämä liittyy"></span>
                    Työjono {{ tyojono.tyojonoUri }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <pre>{{ tyojono.data | json }}</pre>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
        @if (lemonatorLoading()) {
          <div>
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Eräajot">
      <div class="light-blue-text otsikko" style="margin-top: 1em">
        <div style="margin-right: auto">Ajastetut eräajot (Cloud Scheduler)</div>
        <button mat-button class="secondarybutton" (click)="paivitaEraajotStatus()" [disabled]="eraajotLatauksessa$ | async">
          @if (eraajotLatauksessa$ | async) {
            Päivitetään…
          } @else {
            Päivitä
          }
        </button>
      </div>

      @if (eraajotStatus$ | async; as eraajotResp) {
        <div style="margin: 0.5em 0 1em 0.5em">
          <small>Tilanne haettu: {{ muotoileIso(eraajotResp.haettuIso) }}</small>
        </div>
        <div class="eraajot-progress-wrapper">
          @if (eraajotLatauksessa$ | async) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }
        </div>
        <table class="eraajot-table" matSort matSortActive="valo" matSortDirection="asc" matSortDisableClear [class.eraajot-table--latauksessa]="eraajotLatauksessa$ | async">
          <thead>
            <tr>
              <th mat-sort-header="valo"></th>
              <th mat-sort-header="projekti">Projekti</th>
              <th mat-sort-header="selite">Eräajo (Scheduler-nimi / topic)</th>
              <th mat-sort-header="seuraavaOdotettuAjoIso">Seuraava odotettu</th>
              <th mat-sort-header="lastSucceededIso">Viimeisin onnistunut</th>
              <th>Status / virhe</th>
            </tr>
          </thead>
          <tbody>
            @for (tila of eraajotResp.tilat; track trackEraajoRivi($index, tila)) {
              <tr [class.eraajo-rivi-duplikaatti]="tila.topicJobMaara > 1">
                <td>
                  <span class="status-dot" [ngClass]="'status-dot-' + tila.valo" [title]="tila.valoSelite"></span>
                </td>
                <td>{{ tila.projekti }}</td>
                <td>
                  <div>
                    <a [href]="annaSchedulerLinkki(tila)" target="_blank" rel="noopener">{{ tila.selite }}</a>
                  </div>
                  <div class="eraajo-topic">
                    topic:
                    @if (tila.onkoStatusDokumentti) {
                      <a [href]="annaStatusDokumenttiLinkki(tila)" target="_blank" rel="noopener">{{ tila.topic }}</a>
                    } @else {
                      {{ tila.topic }}
                    }
                  </div>
                  @if (tila.topicJobMaara > 1) {
                    <div class="eraajo-duplikaatti-varoitus">⚠ Duplikaatti: topicilla on {{ tila.topicJobMaara }} scheduleria (policy: 1 per topic)</div>
                  }
                </td>
                <td class="eraajo-aika">{{ muotoileIso(tila.seuraavaOdotettuAjoIso) }}</td>
                <td class="eraajo-aika">{{ muotoileIso(tila.lastSucceededIso) }}</td>
                <td>
                  {{ tila.valoSelite }}
                  @if (tila.lastFailedIso) {
                    <div class="eraajo-virhe">Epäonnistui {{ muotoileIso(tila.lastFailedIso) }}</div>
                  }
                  @if (tila.lastError) {
                    <div class="eraajo-virhe">{{ tila.lastError }}</div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>

        @if (eraajotResp.orvot.length > 0) {
          <h4 style="margin-top: 1.5em">Orvot status-dokumentit — handler on ajanut mutta Cloud Schedulerissa ei vastaavaa jobia ({{ eraajotResp.orvot.length }})</h4>
          <ul>
            @for (orpo of eraajotResp.orvot; track trackOrpoRivi($index, orpo)) {
              <li>
                {{ orpo.projekti }}:
                <strong
                  ><a [href]="annaStatusDokumenttiLinkki(orpo)" target="_blank" rel="noopener">{{ orpo.topic }}</a></strong
                >
                @if (orpo.lastSucceededIso) {
                  — viimeisin onnistunut {{ muotoileIso(orpo.lastSucceededIso) }}
                }
                @if (orpo.lastFailedIso) {
                  — viimeisin epäonnistunut {{ muotoileIso(orpo.lastFailedIso) }}
                }
              </li>
            }
          </ul>
        }
      } @else if (eraajotLatauksessa$ | async) {
        <div style="margin: 1em 0"><mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner></div>
      }
    </mat-tab>
    <mat-tab label="Mobiilisovellukset">
      <ng-template matTabContent>
        <app-it-mobiilisovelluksien-tilastot></app-it-mobiilisovelluksien-tilastot>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
